<app-status-badge *ngIf="isOnModeration || isDeclined"
                  [status]="item.moderation_status"
                  [reason]="item.moderation_message">
</app-status-badge>
<div class="card-full-main" *ngIf="!pane else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div class="library-block">
    <div *ngIf="isDebug$ | async" class="debug">card-full-main</div>
    <app-content-card
      [item]="item"
      [inline]="false"
      [cut]="false"
      [displayMode]="deviceService.isMobile() ? 'content_page' : 'default'"
      [viewportChange]="true"
      [meta]="true">
    </app-content-card>
  </div>
</ng-template>
